import { render, staticRenderFns } from "./CopyStakeAiStreamerPlanModal.vue?vue&type=template&id=66754790&scoped=true&lang=pug"
import script from "./CopyStakeAiStreamerPlanModal.vue?vue&type=script&lang=ts"
export * from "./CopyStakeAiStreamerPlanModal.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeAiStreamerPlanModal.vue?vue&type=style&index=0&id=66754790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66754790",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VListItem,VRow,VSelect,VTextField})
